<p-confirmDialog key="email" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Menu-->
<div class="MainGrid2Col">
	<!--Instructions-->
	<div style="grid-column: 1/3">
		<p style="font-size: 12px; width: 315px; text-align: left; color: black">
			Enter email that will be used to receive emails from CAASS. This includes password reset and forgot username emails.
		</p>
	</div>

	<label>Username:</label>
	<label class="InfoText">{{ UserName }}</label>

	<label>Email:</label>
	<input [disabled]="IsLoading() == true" class="form-control" type="text" [(ngModel)]="NewEmail" />

	<label>Confirm Email:</label>
	<input [disabled]="IsLoading() == true" class="form-control" type="text" [(ngModel)]="ConfirmEmail" />
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onUpdate()">Confirm</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
